/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { GlobalStatus } from "../../util/utils";
import { QueryData, ResponseData } from "../services/network/NetworkTypes";

interface IntegrationSteps {
  title: string;
  presentation_configuration: string;
  presentations: Record<string, any>;
}
export default class Presentation {
  constructor(
    public id: string,
    public integration_configuration: string,
    public email: string,
    public data_sharing: string,
    public integration_steps: Array<IntegrationSteps>,
    public status: GlobalStatus,
    public created: Date,
    public modified: Date
  ) {}

  static fromJSON(json: Record<string, any>): Presentation {
    /*
  {
    "id": "497f6eca-6276-4993-bfeb-53cbbbba6f08",
    "status": "pending",
    "email": "user@example.com",
    "integration_configuration": "bb08bb65-1881-4e59-9db4-e033c2b46e83",
    "data_sharing": "4221fab1-de08-430d-94c6-bc848d8ecba8",
    "created": "2019-08-24T14:15:22Z",
    "modified": "2019-08-24T14:15:22Z",
    "integration_steps": [
     {
        "title": "string",
        "presentation_configuration": "string",
        "presentations": "string"
      }
    ]
  }
 * */

    return new Presentation(
      json.id,
      json.integration_configuration,
      json.email,
      json.data_sharing,
      json.integration_steps,
      json.status,
      json.created,
      json.modified
    );
  }
}

export type PresentationDataFilter = "search" | "data_sharing";

// Backend keys you can sort with
export type PresentationDataOrder =
  | "id"
  | "integration_configuration"
  | "email"
  | "data_sharing"
  | "integration_steps"
  | "status"
  | "created"
  | "modified";

// This will help transform the sorting from local to backend keys.
export const presentationDataOrderTransform: Record<
  string,
  PresentationDataOrder
> = {
  email: "email",
  integration_configuration: "integration_configuration",
  data_sharing: "data_sharing",
  status: "status",
  integration_steps: "integration_steps",
  modified: "modified",
};

// These are the keys used for table listings
export type PresentationDataTableFields =
  keyof typeof presentationDataOrderTransform;

export type PresentationQueryData = QueryData<
  PresentationDataFilter,
  PresentationDataOrder
>;

export type PresentationResponseData = ResponseData<
  Presentation,
  PresentationDataFilter,
  PresentationDataOrder
>;
